import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSFX } from 'js/hooks/useSFX';

// import selectors
import { getTranslationById } from 'js/store/app/App.selectors';

// import icons
import IconCross from 'js/components/icon/Icon.cross';
import IconPwaInstallButton from 'js/components/icon/Icon.pwa-install-button';

const PWAAndroidPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const { playSFX } = useSFX();

  const promptText = {
    title: useSelector((state) => getTranslationById(state, 'pwa_android_prompt_title', 'Install as an app')),
    description: useSelector((state) =>
      getTranslationById(
        state,
        'pwa_android_prompt_description',
        "Add the Let's Play Outside site to your phone or tablet as an app on your home screen."
      )
    ),
  };

  useEffect(() => {
    const handler = (e) => {
      console.log('beforeinstallprompt event fired');
      e.preventDefault();
      setDeferredPrompt(e);
      setShowPrompt(true);
    };
    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    playSFX('button_tap');
    deferredPrompt.prompt();

    const { outcome } = await deferredPrompt.userChoice;
    console.log(`User ${outcome} the A2HS prompt`);

    setDeferredPrompt(null);
    handleClose();
  };

  const handleClose = () => {
    playSFX('button_tap');
    setIsClosing(true);
    setTimeout(() => {
      setShowPrompt(false);
      setIsClosing(false);
    }, 400);
  };

  if (!showPrompt && !isClosing) return null;

  return (
    <>
      <style>{`
        @keyframes slideUpBounce {
          0% {
            transform: translate(-50%, calc(100% + 110px));
            opacity: 0;
          }
          60% {
            transform: translate(-50%, -130px);
          }
          80% {
            transform: translate(-50%, -100px);
          }
          100% {
            transform: translate(-50%, -110px);
            opacity: 1;
          }
        }

        @keyframes slideDownFade {
          0% {
            transform: translate(-50%, -110px);
            opacity: 1;
          }
          100% {
            transform: translate(-50%, calc(100% + 110px));
            opacity: 0;
          }
        }
      `}</style>
      <div
        className="pwa-prompts pwa-prompts--android"
        style={{
          animation: isClosing
            ? 'slideDownFade 0.4s ease-in forwards'
            : 'slideUpBounce 1.3s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards',
        }}
      >
        <button className="pwa-prompts__closeButton" aria-label="Close prompt" onClick={handleClose}>
          <IconCross color="black" />
        </button>
        <div className="pwa-prompts__title">{promptText.title}</div>
        <div className="pwa-prompts__description" style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
          <button className="pwa-prompts__install" aria-label="Install prompt" onClick={handleInstall}>
            <IconPwaInstallButton className="pwa-prompts__svg" />
          </button>
          <div className="pwa-prompts__description">{promptText.description}</div>
        </div>
      </div>
    </>
  );
};

export default PWAAndroidPrompt;
